import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthJWTService } from './jwt/auth-jwt.service';

@Injectable()
export class AuthGuardLoggedIn implements CanActivate {

  constructor(public authService: AuthService, private authJwtService: AuthJWTService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // get the home url
    const returnUrl = route.queryParams['returnUrl'] || '/dashboard';
    // console.log('return url is', returnUrl);
    // console.log('is authenticated', this.authJwtService.isAuthenticated());
    if (!this.authService.isLoggedIn()) {
      // localStorage.removeItem('userToken');
      return true;
    } else {
      console.log('routing from with auth guard', this.authService.returnUrl);
      this.router.navigate([this.authService.returnUrl]);
      return this.authService.isAuthenticated();
    }

  }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth-guard-logged-in.service.ts